export enum Source {
  Topic = 'TOPIC',
  Storyboard = 'STORYBOARD',
  UsefulLink = 'USEFUL_LINK',
  Stadium = 'STADIUM',
  Onboarding = 'ONBOARDING',
  Image = 'IMG',
  Video = 'VIDEO',
  PDF = 'PDF',
  Document = 'DOCUMENT'
}
